import * as Types from "./insurer.constants";

const INITIAL_INSURER_STATE = {
  isLoading: false,
  list: [],
  error: "",
};

export default function InsurersReducer(state = INITIAL_INSURER_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case Types.GET_INSURERS.START:
      return {
        ...state,
        isLoading: true,
      };

    case Types.GET_INSURERS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: payload,
      };

    case Types.GET_INSURERS.ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case Types.GET_INSURERS.CLEAR:
      return INITIAL_INSURER_STATE;

    default:
      return state;
  }
}
